import classNames from 'classnames';
import { ISnowStatus, OpenFlag } from 'api/resort/types';
import { SnowUnit } from 'components/blocks/Unit';

import { isEmpty } from 'util/isEmpty';
import { DateTime } from 'luxon';
import { DATE_ATOM } from 'util/formatDate';
import cellStyles from './styles.module.scss';

interface ISnowfallCellProps {
  openFlag?: OpenFlag
  currentWeather?: ISnowStatus
  noValue: string
  is72hoursReport?: boolean
  updatedAt? : string
}

const SnowfallCell = ({
  openFlag, currentWeather, noValue, is72hoursReport, updatedAt,
}: ISnowfallCellProps) => {
  const value = is72hoursReport ? currentWeather?.last72 : currentWeather?.last24;
  const showSnowValue = !isEmpty(value) && (openFlag !== OpenFlag.NoReportAvailable);
  const dateTimeNow = DateTime.now();
  const updatedAtDateTime = updatedAt && DateTime.fromFormat(updatedAt, DATE_ATOM);
  const isOutdated = updatedAt && updatedAtDateTime
   && dateTimeNow.diff(updatedAtDateTime, 'hours').hours > 48;

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      { showSnowValue && !isOutdated
        ? <SnowUnit values={value} />
        : noValue }
      <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>
    </span>
  );
};

export default SnowfallCell;
